import { render, staticRenderFns } from "./BillsOfMaterials.vue?vue&type=template&id=17bcf025&scoped=true&"
import script from "./BillsOfMaterials.vue?vue&type=script&lang=js&"
export * from "./BillsOfMaterials.vue?vue&type=script&lang=js&"
import style0 from "./BillsOfMaterials.vue?vue&type=style&index=0&id=17bcf025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bcf025",
  null
  
)

export default component.exports